import NativeStorage from "@/utils/nativeStorage/local_storage";
import { PRESISITE_INS_HEADER } from "@/utils/nativeStorage/local_keys";
class IgSetHeaders {
  private headersModule: any = null;

  public updateUserHeaders(value: Record<string, string>, userId: string) {
    const headers = this.headersModule[userId] || {};
    const newHeaders = { ...headers, ...value };
    this.headersModule[userId] = newHeaders;
    NativeStorage.set(PRESISITE_INS_HEADER, this.headersModule);
  }

  public async getUserHeaders(user_id: string = "") {
    const userId = user_id ? "" + user_id : "unkown";
    await this.initHeaders();
    const getHeaders =
      this.headersModule[userId] || this.headersModule.unkown || {};
    return getHeaders;
  }

  private async initHeaders() {
    if (!this.headersModule) {
      this.headersModule =
        (await NativeStorage.get(PRESISITE_INS_HEADER)) || {};
    }
  }
}

export default new IgSetHeaders();
